"use strict";

module.exports = [];